<obg-m-dialog-layout #dialog dialogId="multi-deposit-limit" [hideFooter]="true">
	<obg-m-multi-deposit-limit-container
		(navigate)="onNavigate()"
		navigateToReturnUrl
		autoFocusDisabled
		collapseDepositInfo
		hideDepositLimitCalculatorBanner
		test-id="multi-deposit-limit-container"
		data-test-id="multi-deposit-limit-container"
	>
	</obg-m-multi-deposit-limit-container>
</obg-m-dialog-layout>
